import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { PromotionsPolling } from '@bcraft-frontend-lib/promotions'

import { selectIsUserAuthenticated } from 'features/auth/selectors'

import BalancePolling from './BalancePolling/BalancePolling'
import CarouselSliderPolling from './CarouselSliderPolling'
import LimitsPolling from './LimitsPolling/LimitsPolling'

export const AppGlobalPolling = () => {
  const isAuth = useSelector(selectIsUserAuthenticated, shallowEqual)

  return (
    <>
      <BalancePolling key={String(isAuth)} />
      <PromotionsPolling isAuth={isAuth} />
      <LimitsPolling />
      <CarouselSliderPolling />
    </>
  )
}
